import React from "react";
import TextField from "@material-ui/core/TextField";

type Props = {
  value: Record<string, unknown>;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestValue({value, onChange}: Props) {
  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <TextField
        value={value.find_key}
        onChange={event => onChange({...value, find_key: event.target.value})}
        label="Match Key"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={value.find_value}
        onChange={event => onChange({...value, find_value: event.target.value})}
        label="Match Value (regex, eg: ab*)"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={value.test_key}
        onChange={event => onChange({...value, test_key: event.target.value})}
        label="Test Key"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={value.test_value}
        onChange={event => onChange({...value, test_value: event.target.value})}
        label="Test Value (regex, eg: ab*)"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
    </div>
  );
}
